import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyAlbersMode({ brand }: ModeRendererProps) {
  // Color discipline and optical rigor; layered hierarchy
  // Nested squares, contrast studies, value steps
  
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.paper} />
      
      {/* Main Albers "Homage to the Square" compositions */}
      {/* Top left - aqua progression */}
      <g transform="translate(140, 120)">
        {[180, 140, 100, 60].map((size, i) => {
          const offset = (180 - size) / 2;
          const colors = [brand.aqua, brand.violet, brand.deep, brand.amber];
          return (
            <rect
              key={`square-tl-${i}`}
              x={offset}
              y={offset + i * 8}
              width={size}
              height={size}
              fill={colors[i]}
              opacity={0.85}
            />
          );
        })}
      </g>
      
      {/* Top right - violet progression */}
      <g transform="translate(460, 120)">
        {[180, 140, 100, 60].map((size, i) => {
          const offset = (180 - size) / 2;
          const colors = [brand.violet, brand.aqua, brand.amber, brand.white];
          return (
            <rect
              key={`square-tr-${i}`}
              x={offset}
              y={offset + i * 8}
              width={size}
              height={size}
              fill={colors[i]}
              opacity={0.85}
            />
          );
        })}
      </g>
      
      {/* Middle section - value steps */}
      {Array.from({ length: 8 }).map((_, i) => {
        const x = 80 + i * 80;
        const y = 400;
        const opacity = 0.2 + (i / 7) * 0.7;
        
        return (
          <rect
            key={`value-step-${i}`}
            x={x}
            y={y}
            width={75}
            height={140}
            fill={brand.deep}
            opacity={opacity}
          />
        );
      })}
      
      {/* Contrast study - nested squares with optical effects */}
      <g transform="translate(240, 650)">
        {Array.from({ length: 10 }).map((_, i) => {
          const size = 240 - i * 24;
          const offset = i * 12;
          const colors = [brand.aqua, brand.violet, brand.amber, brand.deep, brand.white];
          
          return (
            <rect
              key={`nested-${i}`}
              x={offset}
              y={offset}
              width={size}
              height={size}
              fill={colors[i % colors.length]}
              opacity={0.7}
            />
          );
        })}
      </g>
      
      {/* Color interaction grid - Albers studies */}
      {Array.from({ length: 5 }).map((_, row) =>
        Array.from({ length: 7 }).map((_, col) => {
          const x = 80 + col * 90;
          const y = 950 + row * 32;
          const colors = [brand.aqua, brand.violet, brand.amber];
          const bgColor = colors[(row + col) % 3];
          const fgColor = colors[(row + col + 1) % 3];
          
          return (
            <g key={`interaction-${row}-${col}`}>
              <rect x={x} y={y} width={80} height={28} fill={bgColor} opacity={0.8} />
              <rect x={x + 20} y={y + 7} width={40} height={14} fill={fgColor} opacity={0.9} />
            </g>
          );
        })
      )}
      
      {/* Vasarely optical overlay - concentric squares */}
      <g transform="translate(560, 680)">
        {Array.from({ length: 8 }).map((_, i) => {
          const size = 160 - i * 18;
          const offset = i * 9;
          return (
            <rect
              key={`optical-overlay-${i}`}
              x={offset}
              y={offset}
              width={size}
              height={size}
              fill="none"
              stroke={i % 2 === 0 ? brand.white : brand.deep}
              strokeWidth="2"
              opacity={0.4}
            />
          );
        })}
      </g>
      
      {/* Hierarchy demonstration with size and color */}
      {[1, 0.75, 0.5, 0.35, 0.25].map((scale, i) => {
        const size = 100 * scale;
        const x = 120 + i * 120;
        const y = 580 - size / 2;
        const colors = [brand.violet, brand.aqua, brand.amber, brand.deep, brand.white];
        
        return (
          <rect
            key={`hierarchy-${i}`}
            x={x - size / 2}
            y={y}
            width={size}
            height={size}
            fill={colors[i]}
            opacity={0.8}
          />
        );
      })}
    </g>
  );
}
